/* eslint-disable-next-line no-restricted-imports */
import * as t from 'io-ts';

export const tBoostConfig = t.intersection([
  t.type({
    id: t.number,
    favicon_url: t.string,
    show_age_gate: t.boolean,
    disable_jane_title_and_description_meta: t.boolean,
    google_sso_client_id: t.union([t.string, t.null]),
    google_sso_client_secret: t.union([t.string, t.null]),
    custom_product_detail_title_suffix: t.string,
    integration_method: t.string,
    legacy_id: t.union([t.number, t.null]),
  }),
  t.partial({
    boost_menu_id: t.number,
    partner_menu_url: t.union([t.string, t.null]),
    sitemap_url: t.string,
    header: t.string,
    footer: t.string,
    page_head: t.string,
    enabled: t.boolean,
  }),
  t.partial({
    boost_menu_id: t.number,
    preview_template_url: t.union([t.string, t.null]),
    preview_template_html: t.union([t.string, t.null]),
    published_template_auto_import: t.boolean,
    published_template_url: t.union([t.string, t.null]),
    published_template_html: t.union([t.string, t.null]),
    host: t.string,
    path: t.union([t.string, t.null]),
    content_selector: t.string,
    google_search_console_api_key: t.union([t.string, t.null]),
    google_search_console_api_secret: t.union([t.string, t.null]),
  }),
  t.partial({
    boost_menu_id: t.number,
    preview_template_url: t.union([t.string, t.null]),
    preview_template_html: t.union([t.string, t.null]),
    published_template_auto_import: t.boolean,
    published_template_url: t.union([t.string, t.null]),
    published_template_html: t.union([t.string, t.null]),
    url: t.string,
    token: t.string,
    content_selector: t.string,
    google_search_console_api_key: t.union([t.string, t.null]),
    google_search_console_api_secret: t.union([t.string, t.null]),
  }),
]);
export type BoostConfig = t.TypeOf<typeof tBoostConfig>;
